/******************************************************************************
 *
 * Copyright (c) 2019-2023 ServiceActivator Inc. All Rights Reserved.
 *
 * Unauthorized copying of the code in this file, completely or partially,
 * via any medium is strictly prohibited.
 *
 * Proprietary and Confidential.
 *
 * Written by 'Rahul Bagaria' <Rahul@wakencode.com>, September 2023
 *
 *****************************************************************************/

import { memo } from "react";
import { AntImage } from "../../antd";
import { IImageProps } from "../../../model/component";

/**
 * This is a functional and memoized componant for customization of antd Image
 * @param width
 * @param src
 * @param preview
 * @param height
 * @param style
 * @param props
 * @returns JSX for custom Image
 */

export const Image = memo(
  ({ width, src, preview, height, style, ...props }: IImageProps) => {
    return (
      <>
        <AntImage
          preview={preview}
          width={width}
          src={src}
          height={height}
          style={style}
          {...props}
        />
      </>
    );
  }
);
